// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2GL7J"};